import { axiosLocal5000Local } from "../axios";

export async function getNotificationStatus(modalCode:any, username:any, notificationEnabled:any){
    // console.log("result in get function", modalCode, username, notificationEnabled)
    return await axiosLocal5000Local.post(`/userprofile/update_notification`,{"s_code":modalCode, "s_username":username, "s_notificationenabled":notificationEnabled})
    .then((res:any)=>{
    return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while updating notification status : ", error)
    return {"error": true}
   
    })
}

export async function updateAll(username:any, notificationEnabled:any){
    // console.log("result in get function", modalCode, username, notificationEnabled)
    return await axiosLocal5000Local.post(`/userprofile/update_all`,{ "s_username":username, "s_notificationenabled":notificationEnabled})
    .then((res:any)=>{
    return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while updating notification status : ", error)
    return {"error": true}
   
    })
}

